import { MessageToolkitBanner } from '../data-models/mkt-banner.interface';

export const MsgToolkitBannerMockConfig: MessageToolkitBanner = {
  mktBannerIconPath:
    'http://dvl1.delta.com/content/dam/delta-applications/ui-kit/assets/svg/bell-icon.svg',
  mktBannerLabel: 'Lorem ipsum dolor sit amet debet dicant munere sit in',
  mktBannerMessage:
    'Lorem ipsum dolor sit amet debet dicant munere sit in. Eam no suscipit dissentias. Lorem ipsum dolor sit amet debet dicant.',
  alertbannerbdrcolor: '',
  alertbannerbgcolor: '',
  alertsubheadingdate: '',
  headerColor: '',
  templateType: '',
  descriptionColor: ''
};
